import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EnumNotification, EnumTheme } from '../../../constants/enums';
import { getCartState } from '../../../Modules/Cart/selectors';
import CheckIcon from '../../Icon/CheckIcon';
import { setNotificationAction } from '../../../Modules/Notifications/actions';

import { ButtonTextContainer, ReadyButton } from './styled';

const READY_TEXT = '✅  Товары в корзине ждут оформления заказа';

export const MultiUserReadyButton = () => {
  const [isReady, setIsReady] = useState(false);
  const dispatch = useDispatch();
  const cart = useSelector(getCartState);

  useEffect(() => {
    setIsReady(false);
  }, [cart.total_price]);

  const handleClick = () => {
    setIsReady(true);
    dispatch(setNotificationAction(READY_TEXT, EnumNotification.info));
  };

  return (
    <ReadyButton use={EnumTheme.roundGreen} onClick={handleClick} disabled={isReady}>
      <ButtonTextContainer>
        {isReady && <CheckIcon />}
        Готово
      </ButtonTextContainer>
    </ReadyButton>
  );
};
